import { CardResponse } from '@shared/api';
import { cn, FormatUtils } from '@shared/utils';
import { Checkbox, Text } from '@shared/widgets';
import { Controller, useFormContext } from 'react-hook-form';

interface CardSelectItemsProps {
  className?: string;
  cards: CardResponse[];
  allSelected?: boolean;
}

export const CardSelectItems = (props: CardSelectItemsProps) => {
  const { control } = useFormContext<{ cards: CardResponse[] }>();

  return (
    <div className={cn('flex flex-col gap-4', props.className)}>
      {props.cards.length === 0 && (
        <Text size='xs' color='secondary'>
          No cards available for this account
        </Text>
      )}
      {props.cards.map((card) => (
        <Controller
          key={card.cardId}
          name='cards'
          control={control}
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={FormatUtils.toSliceNumber(card.cardNumber)}
              readOnly={props.allSelected}
              value={props.allSelected || value.some((c) => c.cardId === card.cardId)}
              onChange={() =>
                onChange(value.some((c) => c.cardId === card.cardId) ? value.filter((c) => c.cardId !== card.cardId) : [...value, card])
              }
            />
          )}
        />
      ))}
    </div>
  );
};
